import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getDidController from './getCallbackDidController.js'
import _module from 'module.js'
import _ from 'lodash'

let getCallbackDidComponent = _.cloneDeep(getJrnDefaultComponent)
getCallbackDidComponent.controller = getDidController

_module.component('getCallbackDid', getCallbackDidComponent)
